// extracted by mini-css-extract-plugin
export default {"r_l":"febbafbb89 _68be209507","t":"_26686f52f4"};